let errorCodes = {
    projectAlreadyExist: 'project-already-exist',
    scriptAlreadyExist: 'script-already-exist',
    tagAlreadyExist: 'tag-already-exist',
    userAlreadyExist: 'user-already-exist',
    userAlreadyVerified: 'user-already-verified',
    passwordAlreadyChanged: 'password-already-changed',
    invalidPassword: 'invalid-password',
    invalidPreviousPassword: 'invalid-previous-password',
    projectNotFound: 'project-not-found',
    scriptNotFound: 'script-not-found',
    taggedScript: 'tagged-script',
    userNotFound: 'user-not-found',
    emailNotConfirmed: 'email-not-confirmed',
    userProfileNotFound: 'user-profile-not-found',
    setProdTag: 'set-prod-tag',
    setStageTag: 'set-stage-tag',
    updateProjectTags: 'update-project-tags',
    deleteProject: 'delete-project',
    scriptNameLengthExceed: 'script-name-length-exceed',
    projectNameLengthExceed: 'project-name-length-exceed',
    verificationEmailSent: 'verification-email-sent',
    lastExtraScripts: 'last-extra-scripts',
    userNotApproved: 'user-not-approved',
    userTriesDeleteProdTagId: 'prod-tag-id',
    conversationAlreadyExist: 'testconversation-already-exists',
    createCustomerError: 'create-customer-error',
    customerNotExists: 'customer-not-exists',
    balanceNotExists: 'balance-not-exists',
    userIsSuspended: 'user-is-suspended',
    promoNotFound: 'promo-not-found',
    promoNotApplicable: 'promo-not-applicable',
    promoAlreadyApplied: 'promo-already-applied',
    noImage: 'no-image',
    passwordTooShort: 'password-too-short',
    oauthFailedSignin: 'oauth-failed-signin',
    paymentOtherError: 'payment-other-error',
    scriptError: 'script-error',
    invalidAuthResponse: 'invalid-auth-response',
    unauthorized: 'unauthorized',
    invalidEmail: 'invalid-email',
    noGithubLogin: 'no-github-login',
    unathorizedInGithub: 'unathorized-in-github',
    notPaidUser: 'not-paid-user',
    notEnoughMoney: 'not-enough-money',
    cardVerificationRequired: 'card-verification-required',
    permissionDenied: 'permission-denied',
    undefinedGithubToken: 'undefined-github-token',
    invalidGithubToken: 'invalid-github-token',
    githubRepoError: 'github-repo-error',
    githubRepoNotFound: 'github-repo-not-found',
    githubRepoDirNotFound: 'github-repo-dir-not-found',
    noGithubRepoScope: 'no-repo-scope',
    planAlreadyCancelled: 'plan-already-cancelled',
    planAlreadyResumed: 'plan-already-resumed',
    planAlreadyConfirmed: 'plan-already-confirmed',
    planCancelled: 'plan-cancelled',
    passwordIsEmpty: 'password-is-empty',
    decryptionError: 'decryption-error',
    invitationEmailWasResent: 'invitation-email-was-resent',
    githubAccountAlreadyAssigned: 'github-account-already-assigned',
    buttonOptionsAlreadyExists: 'button-options-already-exists',
    orgExists: 'org-exists',
    orgUserExists: 'org-user-exists',
    userDiffOrg: 'user-diff-org',
    orgUserNotExists: 'org-user-not-exists',
    orgNotFound: 'org-not-found',
    orgWithMembers: 'org-with-members',
    userOrgOwner: 'user-org-owner',
    moneyAmountGreaterHundred: 'money-amount-greater-100',
    badMoneyPromoEmail: 'bad-money-promo-email',
    invalidCall: 'invalid-call',
};

export default errorCodes;